<div @show class="body">

    <ng-container *ngIf="items.length > 0; else noItems">

        <div class="item-wrapper" *ngFor="let item of items">
            
            <div class="header">
                Artikel {{item.itemproduct|product|async}} {{item.itemname}}
            </div>

            <div class="info" *ngIf="item.itemdesc">
                {{item.itemdesc}}
            </div>

            <div class="sub-title-wrapper">
                In den folgenden Vertrag buchen
            </div>

            <ng-container *ngFor="let contract of contracts">
            
                <div class="contract-wrapper" (click)="setMapping(item, contract)">

                    <mat-checkbox [checked]="mappingReadOnly[item.itemid] === contract.contractid" (click)="$event.preventDefault()"></mat-checkbox>
                    <div class="text">
                        {{contract.contractnumber}} {{contract.contractdesc}}
                    </div>

                </div>

            </ng-container>
            
        </div>

    </ng-container>

</div>

<ng-template #noItems>

    <div class="no-items-hint">

        <div class="text">Keine Vorgangsartikel</div>

    </div>

</ng-template>
